import { CalendarViewTypeEnum, DEFAULT_CALENDAR_VIEW_TYPE } from 'owa-calendar-view-type';
import { isFeatureEnabled } from 'owa-feature-flags';

// TODO: VSO #93977 Rationalize module routing when canvas view type is explicitly specified for surface-only routes
// Once the above is addressed, we should remove the `forceSurfaceViewType` shim
export function processCalendarViewType(
    viewType: CalendarViewTypeEnum,
    forceSurfaceViewType?: boolean
): CalendarViewTypeEnum {
    if (
        (!isFeatureEnabled('cal-sublimity') || forceSurfaceViewType) &&
        viewType === CalendarViewTypeEnum.Canvas
    ) {
        return DEFAULT_CALENDAR_VIEW_TYPE;
    }
    return viewType;
}
